module.exports = __webpack_public_path__ + "static/media/Geoparc_EN.b499f960.mp4";